<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật đăng kí: {{ modelData.user_name }} - {{ modelData.user_email }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row :gutter="20">
      <div class="model-content">
        <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
          <el-col :span="18">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item prop="school_id" label="Chọn trường" class="form-item">
                  <el-select v-model="modelData.school_id" filterable placeholder="" class="input-select">
                    <el-option
                      v-for="item in lists.listSchool"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <p>Phân hệ: <strong>{{ modelData.level_text }}</strong></p>
                <p>Chuyên ngành: <strong>{{ modelData.facult_text }}</strong></p>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="staff_code" label="Mã nhân viên xử lý" class="form-item">
                  <el-input
                    :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
                    v-model="modelData.staff_code" class="input-seach" placeholder="cati-00086">
                  </el-input>
                </el-form-item>
                <span v-if="this.modelStaff.name">
                  <strong>Họ tên: {{ this.modelStaff.name }}</strong>/
                  <strong>Email: {{ this.modelStaff.email }}</strong>
                </span>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="total_money" label="Số tiền cần thu" class="form-item">
                  <el-input
                    v-model="modelData.total_money" class="input-seach">
                    <template slot="append">{{ modelData.total_money | vnd }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Đăng kí'
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  data () {
    return {
      canSubmit: true,
      searching: false,
      loadingDone: false,
      modelData: {
        level_id: '',
        facult_id: '',
        specialized_id: '',
        total_money: '',
        key_id: '',
        user_id: '',
        list_courses: [],
        name: '',
        code: '',
        status: true
      },
      modelStaff: {

      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: [],
        listTeacher: [],
        listCourses: []
      },
      rules: {
        school_id: [
          { required: true, message: 'Vui lòng nhập trường' }
        ],
        total_money: [
          { required: true, message: 'Vui lòng nhập số tiền cần thu' }
        ],
        staff_code: [
          { required: true, message: 'Vui lòng nhập mã nhân viên xử lý' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-users-index', text: 'Đăng kí' },
        { name: 'class-users-create', text: 'Cập nhật' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'class-users-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('class-users/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            setTimeout(() => {
              this.loadingDone = true
            }, 2000)
            this.fetchSchool()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            this.modelData.staff_code = this.accountInfo.user_code
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchLevel () {
      axios.get('levels', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchKey () {
      axios.get('keys', {params: {'status': 1, level_id: this.modelData.level_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listKey = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      axios.get('facults', {params: {'status': 1, level_id: this.modelData.level_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'level_id': this.modelData.level_id,
        'facult_id': this.modelData.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'user_type': 2, 'school_id_list': this.accountInfo.school_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    fetchListCourses () {
      axios.get('courses', {params: {'status': 1, 'type': 1, 'school_id': this.accountInfo.school_id}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCourses = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('class-users/update-school-id-v2/' + this.$route.params.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.$router.push({name: 'class-users-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchStaffCode () {
      if (this.modelData.staff_code) {
        let dataTemp = {
          'staff_code': this.modelData.staff_code
        }
        axios.post('class-users/fetch-staff-id-v2', dataTemp).then(response => {
          switch (response.code) {
            case 200:
              this.modelStaff = response.data
              break
            case 404:
              this.$notify({
                title: 'Có lỗi xảy ra',
                message: 'Không tìm được mã nhân viên vừa nhập',
                type: 'warning'
              })
              break
            default:
              this.$notify.error({
                title: 'Error',
                message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
              })
              break
          }
        })
      } else {
        this.modelStaff.name = ''
      }
    }
  },
  watch: {
    'modelData.staff_code': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchStaffCode()
      }, 1200)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-users-v2/Update.vue